import { useCallback } from 'react'
import { useAnnouncementsContext } from 'services/AnnouncementsService/context'
import { useAnnouncements } from 'services/AnnouncementsService/useAnnouncements'
import type { UserAnnouncement } from 'shared/graphql/graphql'

export const usePageAnnouncements = () => {
  const { loading, list, loadMore, hasMoreElements, markAnnouncementSeen } = useAnnouncements()
  const { openAnnouncement } = useAnnouncementsContext()

  const handleClick = useCallback(
    (announcement: UserAnnouncement) => {
      openAnnouncement(announcement)

      if (!announcement.seen) {
        markAnnouncementSeen(announcement)
      }
    },
    [markAnnouncementSeen, openAnnouncement],
  )

  return { handleClick, loading, list, loadMore, hasMoreElements }
}
